import { Component, Input, OnInit } from '@angular/core';
import { Event, NavigationEnd } from '@angular/router';
import { CasinoComponent } from '../casino.component';

@Component({
  selector: 'app-d-casino',
  templateUrl: './d-casino.component.html',
  styleUrls: ['./d-casino.component.css']
})
export class DCasinoComponent extends CasinoComponent implements OnInit {
  @Input() gameId: any;

  ngOnInit(): void {
    this.getData();
    this.onRoutChange();
  }

  onRoutChange() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {

        if (this.id != this.actRoute.snapshot.paramMap.get('id')) {
          this.id = Number(this.actRoute.snapshot.paramMap.get('id'));
          this.getData();
        }
      }
    })
  }

  ngOnChanges() {
    this.id = Number(this.gameId);
  }

}
